import authAxios from "../utils/authAxios"; // Ensure customFetch is updated to use Axios

const presetClient = {

    getPresetsByDeckType: async (deckType, deckId, locale, translateLocale) => {
        const url = `/api/presets?deckType=${deckType}&deckId=${deckId}&locale=${locale}&translateLocale=${translateLocale}`;
        return await authAxios(url, {
            method: 'GET',
        });
    },

    addPresetToClient: async (deckId, deckType, presetId) => {
        return await authAxios('/api/presets/add', {
            method: 'POST',
            data: { deckId, deckType, presetId },
        });
    },


    removePresetFromClient: async (deckId, deckType, presetId) => {
        return await authAxios('/api/presets/remove', {
            method: 'POST',
            data: { deckId, deckType, presetId },
        });
    },
};

export default presetClient;
